var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-picker-wrapper"},[_c('el-time-picker',{ref:"timePicker",style:({ width: '100%' }),attrs:{"value-format":"HH:mm","format":"HH:mm","picker-options":{
      selectableRange: '00:00:00 - 23:59:59'
    },"placeholder":_vm.displayPlaceholder,"disabled":!_vm.disabled},on:{"change":_vm.handleTimeChange},model:{value:(_vm.selectedTime),callback:function ($$v) {_vm.selectedTime=$$v},expression:"selectedTime"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }